const initailState = {
  confirmlotsPayment: [],
  remainUncheck: [],
  loadings: false,
};

export function confirmLotsPaymentsReducer(
  state = initailState,
  { type, payload1, payload2 }
) {
  switch (type) {
    case "CONFIRM_LOTS_PAYMENTS":
      return {
        ...state,
        confirmlotsPayment: payload1,
        remainUncheck: payload2,
        loadings: false,
      };
    case "PAYMENT_LOTS_LOADING":
      return { ...state, loadings: true };
    case "PAYMENT_LOTS_LOADDED":
      return { ...state, loadings: false };

    default:
      return state;
  }
}

export function PayDepositReducer(
  state = {
    loadings: false,
  },
  { type, payload }
) {
  switch (type) {
    case "PAY_DEPOSIT":
      return { ...state, loadings: false };
    case "DEPOSIT_LOADING":
      return { ...state, payload, loadings: true };
    case "DEPOSIT_LOADED":
      return { ...state, payload, loadings: false };

    default:
      return state;
  }
}
